export const TAG = "Tag";
export const CONTENT_BLOCK = "ContentBlock";
export const REPEATING_CONTENT_BLOCK = "RepeatingSection";
export const REPEATING_TABLE_BLOCK = "RepeatingTableSection";
export const DICTATION_CONTENT_BLOCK = "DictationContentBlock";
export const SECTION = "Section";
export const HTML_CONTENT_BLOCK = "HtmlContentBlock";